<mat-toolbar class="p-0 mat-elevation-z1 app-toolbar">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/mvfactory.png">
                </div>
            </div>

            <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start center" class="ml-8">
                    <h1>{{ 'APP.LONG_NAME' | translate}}</h1>
                </div>
            </div>

        </div>
       
        <ng-container *ngIf="(currentUser$ | async) as user">
            <div fxFlex="1 1 auto" fxLayoutAlign="end center">
                <!-- <mat-form-field appearance="" class="mx-12" fxFlex="1 1 100px">
                    <mat-label>{{'TOOLBAR.SELECT-COUNTRY' | translate}}</mat-label>
                    <mat-select  [value]="_tenantSelectorService.selectedTenant|async" (selectionChange)="_tenantSelectorService.selectTenant($event.value)">
                        <mat-option *ngFor="let tenant of (_tenantSelectorService.tenants | async)"
                                    [value]="tenant">
                        {{tenant.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                

                <!--Reports-->
                <button mat-icon-button
                        class="quick-panel-toggle-button"
                        (click)="toggleSidebarOpen(panels.reportPanel)"
                        aria-label="Toggle reports panel" *ngIf="reportsButton">
                    <mat-icon
                        class="secondary-text"
                        matBadge="{{newReports}}"
                        matBadgeOverlap="true"
                        matBadgePosition="below"
                        matBadgeHidden="newReports == 0">
                            description
                    </mat-icon>
                </button>
                <!--Notifications-->
                <button mat-icon-button
                        class="quick-panel-toggle-button"
                        (click)="toggleSidebarOpen(panels.notificationPanel)"
                        aria-label="Toggle notifications panel">
                    <mat-icon
                        class="secondary-text"
                        matBadge="{{newAlerts}}"
                        matBadgeOverlap="true"
                        matBadgePosition="below"
                        matBadgeHidden="newAlerts == 0">
                            notifications
                    </mat-icon>
                </button>

                <language-selector fxHide.sm fxHide.xs></language-selector>

                <ng-container *ngIf="(tenants$ | async); let tenants">
                    <ng-container *ngIf="tenants?.length > 0">
                        <mat-form-field fxFlex="0 0 15rem" appearance="outline" class="m-4" style="border-radius: 5px;" fxHide.sm fxHide.xs>
                        <mat-label>Tenants</mat-label>
                        <mat-select class="p-8" [(value)]="selected" (selectionChange)="selectTenant($event.value)">
                            <mat-option *ngFor="let tenant of tenants" [value]="tenant">
                                <div style="width: 100%">{{tenant.description}}</div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </ng-container>
                    
                </ng-container>

                <div id="user-profile-container" fxFlex="0 1 110px" style="backdrop-filter: brightness(0.5)" fxLayout="row" fxLayoutAlign="end">
                    <div [matMenuTriggerFor]="userMenu" class="user-button pt-4">
                        <div fxLayout="row wrap" fxLayoutAlign="center center">
                            <!-- <ngx-avatar fxFlex="100%" class="avatar mr-0" size="40"
                                [src]="user.urlAvatarInterno" [name]="user.fullUserName"
                                [round]="true" fgColor="var(--theme-primary-color-contrast-500)" borderColor="#2d2d2d" bgColor="var(--theme-primary-color-500)">
                            </ngx-avatar> -->
                            <div class="avatar">
                                <igx-avatar size="large" [initials]="user.initials" shape="circle"></igx-avatar>
                            </div>
                            <!-- <span class="username mr-12" fxHide fxShow.gt-sm>
                            {{ user.fullUserName }}
                            </span> -->
                            <mat-icon fxFlex="100%" class="s-16 white-text" fxHide.xs>keyboard_arrow_down</mat-icon>
                        </div>
                    </div>
                </div>
                
                <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                    <!-- <button mat-menu-item><mat-icon>account_circle</mat-icon><span>My Profile</span></button>
                         <button mat-menu-item class=""><mat-icon>mail</mat-icon><span>Inbox</span></button> -->
                    <ng-container *ngIf="(tenants$ | async); let tenants">
                        <ng-container *ngIf="tenants?.length > 0">
                            <mat-form-field (click)="$event.stopPropagation();"
                                fxFlex="0 0 23rem" appearance="outline" class="m-4" style="border-radius: 5px;" fxHide.md fxHide.lg fxHide.xl>
                            <mat-label>Tenants</mat-label>
                            <mat-select class="p-8" [(value)]="selected" (selectionChange)="selectTenant($event.value)">
                                <mat-option *ngFor="let tenant of tenants" [value]="tenant">
                                    <div style="width: 100%">{{tenant.description}}</div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        </ng-container>
                        
                    </ng-container>

                    <language-selector class="mt-8" fxFlex="0 0 23rem" 
                        fxHide.md fxHide.lg fxHide.xl></language-selector>

                    <mat-divider fxHide.md fxHide.lg fxHide.xl></mat-divider>
                    
                    <button mat-menu-item class="" (click)="openTenantThemeSettings()"><!--fxHide.sm fxHide.xs-->
                        <mat-icon color="accent">palette</mat-icon>
                        <span>{{ 'LABELS.THEME' | translate }}</span>
                    </button>
                    <button mat-menu-item class="" (click)="openGlobalThemeSettings()" *ngIf="canAdminGlobalContent"><!--fxHide.sm fxHide.xs-->
                        <mat-icon color="accent">palette</mat-icon>
                        <span>{{ 'LABELS.GLOBAL_THEME' | translate }}</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item class="" (click)="logout()">
                        <mat-icon>exit_to_app</mat-icon>
                        <span>{{ 'LABELS.LOGOUT' | translate }}</span>
                    </button>
                    <mat-divider></mat-divider>
                    <div style="text-align: end"  class="pt-8 pr-16">
                        <span>Version: {{version}}</span>
                    </div>
                </mat-menu>
            </div>
        </ng-container>

<!--        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">-->

<!--            <button mat-button [matMenuTriggerFor]="userMenu"-->
<!--                    class="user-button">-->
<!--                <div fxLayout="row" fxLayoutAlign="center center">-->
<!--                    <img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/Velazquez.jpg">-->
<!--                    <span class="username mr-12" fxHide fxShow.gt-sm>Charlie Adams</span>-->
<!--                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>-->
<!--                </div>-->
<!--            </button>-->

<!--            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">-->

<!--                <button mat-menu-item>-->
<!--                    <mat-icon>account_circle</mat-icon>-->
<!--                    <span>My Profile</span>-->
<!--                </button>-->

<!--                <button mat-menu-item class="">-->
<!--                    <mat-icon>mail</mat-icon>-->
<!--                    <span>Inbox</span>-->
<!--                </button>-->

<!--                <button mat-menu-item class="">-->
<!--                    <mat-icon>exit_to_app</mat-icon>-->
<!--                    <span>Logout</span>-->
<!--                </button>-->

<!--            </mat-menu>-->

<!--&lt;!&ndash;            <div class="toolbar-separator"></div>&ndash;&gt;-->

<!--&lt;!&ndash;            <fuse-search-bar (input)="search($event)"></fuse-search-bar>&ndash;&gt;-->

            <!-- <div class="toolbar-separator"></div> -->

            <div >
                
            </div>
            

            

<!--            <div class="toolbar-separator" fxHide fxShow.gt-xs></div>-->

<!--&lt;!&ndash;            <button mat-icon-button&ndash;&gt;-->
<!--&lt;!&ndash;                    class="quick-panel-toggle-button"&ndash;&gt;-->
<!--&lt;!&ndash;                    (click)="toggleSidebarOpen('quickPanel')"&ndash;&gt;-->
<!--&lt;!&ndash;                    aria-label="Toggle quick panel">&ndash;&gt;-->
<!--&lt;!&ndash;                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;            </button>&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>&ndash;&gt;-->

<!--            <button mat-icon-button class="navbar-toggle-button"-->
<!--                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>-->
<!--                <mat-icon class="secondary-text">menu</mat-icon>-->
<!--            </button>-->

<!--        </div>-->

    </div>

</mat-toolbar>
